<template>
  <div
    class="cell"
    v-on:click="click($event)"
    v-on:mouseover="mouseover($event)"
    v-bind:class="{ selected, filled: value }"
    v-bind:data-row="row"
    v-bind:data-col="col"
    v-bind:style="{
      gridColumnStart: col,
      gridRowStart: row,
    }"
  >
    <drop @drop="handleDrop" @dragenter="handleEnter">
      <drag
        @dragstart="startdrag"
        @dragend="enddrag"
        :transfer-data="{ 
          from: 'grid', 
          img: value, 
          thumbUrl,
          row, 
          col, 
        }"
      >
        <img v-if="value" v-bind:src="thumbUrl" />
      </drag>
    </drop>
  </div>
</template>

<script>
export default {
  inject: ["getImageByValue"],
  data: function() {
    return {
      selected: false,
      counter: 0
    };
  },

  mounted: function() {
    this.$root.$on("cell:selected", ({ col, row }) => {
      if (this.col === col && this.row === row) {
        this.selected = true;
      } else {
        this.selected = false;
      }
    });
    this.$root.$on("cells:deselect", ({ col, row }) => {
      if (this.col === col && this.row === row) {
        this.selected = false;
      }
    });
    this.$root.$on("cells:deselect_all", () => {
      this.selected = false;
    });
  },
  methods: {
    startdrag: function() {
      document.body.classList.add("isDragging");
    },
    
    enddrag: function() {
      document.body.classList.remove("isDragging");
    },

    mouseover: function() {
      this.$root.$emit("cell:selected", { row: this.row, col: this.col });
    },

    handleEnter: function() {
      this.$root.$emit("cell:selected", { row: this.row, col: this.col });
    },

    handleDrop: function(data) {
      console.log("handledrop!")
      const { from, img, thumbUrl } = data;
      const destinationValue = this.value;
      
      this.$root.$emit("did:drag", {
          data,
          toRow: this.row,
          toCol: this.col
      });

      if (from === "list") {
        this.$emit("cell:changed", {
          row: this.row,
          col: this.col,
          thumbUrl,
          img
        });
        this.$root.$emit("image:placed", this.$props, data);
      }
      if (from === "grid") {
        // DESTINATION CELL ALREADY HAD A VALUE
        if (destinationValue) {
          // SWIPE
          this.$emit("cell:changed", {
            row: data.row,
            col: data.col,
            img: destinationValue,
            thumbUrl: this.thumbUrl
          });
          this.$emit("cell:changed", {
            row: this.row,
            col: this.col,
            img,
            thumbUrl
          });
        }
        // DESTINATION CELL HAD NO VALUE
        else {
          this.$root.$emit("cell:emptied", data);
          this.$emit("cell:changed", {
            row: this.row,
            col: this.col,
            img,
            thumbUrl: data.thumbUrl
          });
        }
      }
      if (from === "desc") {
        const { cells } = this.$parent.$props.grid;
        const inGrid = cells.some(c => c.value === data.img);
        // Do nothing if value is the same as dragged image
        if (destinationValue === data.img) {
          return;
        }

        if (inGrid) {
          // IS IN GRID
          if (destinationValue) {
            // Destination had a value

            // if it had a value. Swipe images
            const oldCell = cells.find(c => c.value === data.img);
            this.$emit("cell:changed", {
              row: oldCell.row,
              col: oldCell.col,
              img: destinationValue, // null
              thumbUrl: oldCell.thumbUrl
            });
            this.$emit("cell:changed", {
              row: this.row,
              col: this.col,
              thumbUrl: data.thumbUrl,
              img
            });
          } else {
            // destination had no value
            const oldCell = cells.find(c => c.value === data.img);
            this.$emit("cell:changed", {
              row: oldCell.row,
              col: oldCell.col
            });

            this.$emit("cell:changed", {
              row: this.row,
              col: this.col,
              thumbUrl: data.thumbUrl,
              img
            });
          }
        } else {
          // IS NOT IN GRID
          this.$root.$emit("image:placed", this.$props, data);
          this.$emit("cell:changed", {
            row: this.row,
            col: this.col,
            thumbUrl: data.thumbUrl,
            img
          });
        }
      }
    },
    click: function() {
      if (this.value) {
        const image = this.getImageByValue(this.value);
        this.$root.$emit("image:show", image, true);
      } else {
        this.counter++;
        this.$root.$emit("cell:clicked", {
          row: this.row,
          col: this.col,
          counter: this.counter,
          words: this.words
        });
        this.$root.$emit("cell:selected", { row: this.row, col: this.col });
      }
    }
  },
  props: {
    col: Number,
    row: Number,
    labels: Object,
    status: String,
    value: String,
    thumbUrl: String,
    words: Array,
    isValid: Boolean
  }
};
</script>

<style scoped>
.cell {
  /* background: rgba(255, 255, 255, 0.9); */
  /* background: #5f6368; */
  background: #dddddd;
  transform: translate3d(0, 0, 0);
  border: none;
  /* border: 1px solid #1a73e8; */
  border-radius: 5px;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-size: cover;
  overflow: hidden;
  transition: background-color 0.1s ease;
}

.cell.filled {
  border-color: transparent;
}

img {
  cursor: move;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.cell div {
  widows: 100%;
  height: 100%;
}

.cell svg {
  cursor: pointer;
}

.selected {
  background-color: #669df6;
  /* box-shadow: 0 0 0 2px #1a73e8; */
}

.filled.selected {
  background-color: transparent;
}

.cell::before,
.cell::after {
  font-weight: bold;
  font-size: 14px;
  position: absolute;
  top: 2px;
  left: 2px;
}

.cell::before {
  content: attr(data-horizontal);
}

.cell::after {
  content: attr(data-vertical);
}
/*
.valid {
  border: 2px solid green;
}

.invalid {
  border: 2px solid red;
} */

.cell > div {
  width: 100%;
  height: 100%;
}
</style>
